import type { ContentFieldTypeName } from "./types";

/**
 * Campo que o CMS mantém sozinho em toda entry, sem o racer declarar. Diferente
 * de um `ContentField`, não tem UUID: o `id` repete o `name`, que é o nome da
 * coluna em `ContentEntry` e também a chave na raiz do payload público.
 */
export interface NativeEntryField {
  id: string;
  name: string;
  label: string;
  type: ContentFieldTypeName;
}

/**
 * Cópia deliberada, como `CONTENT_FIELD_TYPES`. A lista é **domínio do cms-api**,
 * que a declara em `ENTRY_NATIVE_FILTER_FIELDS` tipada contra as colunas reais de
 * `ContentEntry` — aquela é a fonte da verdade. Aqui existe só o que o catálogo
 * precisa para oferecer os campos no admin, aceitá-los na validação e conhecer o
 * tipo na emissão; depender do cms-api criaria ciclo.
 *
 * Campo nativo novo entra nos dois lugares.
 */
export const nativeEntryFields = [
  {
    id: "publishAt",
    name: "publishAt",
    label: "Data de publicação",
    type: "datetime",
  },
  {
    id: "unpublishAt",
    name: "unpublishAt",
    label: "Data de retirada",
    type: "datetime",
  },
  {
    id: "createdAt",
    name: "createdAt",
    label: "Data de criação",
    type: "datetime",
  },
  {
    id: "updatedAt",
    name: "updatedAt",
    label: "Atualizado em",
    type: "datetime",
  },
] as const satisfies ReadonlyArray<NativeEntryField>;

export const nativeEntryFieldNames: readonly string[] = nativeEntryFields.map(
  (field) => field.name,
);

/** Tipo por nome, no formato que o `buildNode` espera receber. */
export const nativeEntryFieldTypes: Readonly<
  Record<string, ContentFieldTypeName>
> = Object.fromEntries(
  nativeEntryFields.map((field) => [field.name, field.type]),
);
